export default "/images/9e2d4f38aefa1b88a6da2ee31e4e1dfa.avif";